var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExpansionPanelContainer',{attrs:{"panelsModel":[0]}},[_c('ExpansionPanel',{attrs:{"title":_vm.$t('diagnoses.titles.studentInformation')}},[_c('BasicTable',{attrs:{"headers":_vm.getStudentInformationHeaders,"items":_vm.students}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }